import { useState } from "react";
import classNames from "classnames";
import RenderOnRole from "../../../Utilities/RenderOnRole";

export default function FieldSelector({
    fields = [],
    onChange,
}) {
    const [isOpen, setIsOpen] = useState(false);

    const selectedFields = fields.filter(f => f.active);

    const toggleField = (field) => {
        var fieldInfoObj = fields.find(f => f.id === field.id);
        if (fieldInfoObj !== undefined) fieldInfoObj.active = !fieldInfoObj.active;
        onChange?.(fields);
    };

    return (
        <div style={{ position: "relative", display: "inline-block" }}>
            <button
                type="button"
                onClick={() => setIsOpen((open) => !open)}
                className={classNames(
                    "flex items-center gap-2 rounded-lg border px-3.5 py-2.5",
                    "text-sm font-medium transition-colors",
                    "border-gray-300 bg-white text-gray-900",
                    "hover:bg-gray-50",
                    "dark:border-gray-700 dark:bg-gray-700 dark:text-gray-100",
                    "dark:hover:bg-gray-600",
                    {
                        "bg-gray-100 dark:bg-gray-800": isOpen,
                    }
                )}
            >
                Select fields

                <span
                    className={classNames(
                        "inline-block text-xs transition-transform duration-200",
                        {
                            "rotate-180": isOpen,
                        }
                    )}
                >
                    ▼
                </span>
            </button>

            {isOpen && (
                <div
                    className={classNames(
                        "absolute right-0 top-[calc(100%+8px)] z-50",
                        "w-[360px] max-w-[calc(100vw-32px)]",
                        "rounded-xl border p-4 shadow-xl",
                        "border-gray-200 bg-white",
                        "dark:border-gray-700 dark:bg-gray-900"
                    )}
                >
                    <div className="mb-3 flex items-center justify-between">
                        <div>
                            <div
                                className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                                Fields
                            </div>

                            <div className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
                                {selectedFields.length} of {fields.length} selected
                            </div>
                        </div>
                    </div>

                    <div className="flex max-h-[350px] flex-col gap-1.5 overflow-y-auto">
                        {fields.map((field) => {
                            const isSelected = selectedFields.includes(field);
                            var roles = field.employeeOnly ? ["Administrator", "SD_Medewerker"] : ["Administrator", "SD_Medewerker", "Klant"];
                            return (
                                <RenderOnRole
                                    key={"renderOnRoleNode" + field.id}
                                    roles={roles}
                                >
                                    <label
                                        key={field.id}
                                        className={classNames(
                                            "flex cursor-pointer items-center gap-3 rounded-lg border",
                                            "px-3 py-2.5 transition-colors",
                                            "border-transparent",
                                            "hover:bg-gray-50",
                                            "dark:hover:bg-gray-800",
                                            {
                                                "border-green-200 bg-green-50 dark:border-green-900 dark:bg-green-950/40":
                                                    isSelected,
                                            }
                                        )}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={field.active}
                                            onChange={() => toggleField(field)}
                                            className="sr-only"
                                        />

                                        <span
                                            className={classNames(
                                                "flex h-[18px] w-[18px] flex-shrink-0 items-center",
                                                "justify-center rounded-[5px] border-2",
                                                "text-xs font-bold transition-colors",
                                                {
                                                    "border-green-600 bg-green-600 text-white dark:border-green-500 dark:bg-green-500":
                                                        isSelected,

                                                    "border-gray-300 bg-white text-transparent dark:border-gray-600 dark:bg-gray-800":
                                                        !isSelected,
                                                }
                                            )}
                                        >
                                            <span style={{ transform: "translateY(-0px)" }}>✓</span>
                                        </span>

                                        <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
                                            {field.label}
                                        </span>
                                    </label>
                                </RenderOnRole>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}